// import components
import { Box, styled } from '@mui/material';

export const StyledPeriodSelectorBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(8),
  flexWrap: 'wrap',
  gap: theme.spacing(4)
}));

export const StyledPeriodSelectorRangeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  flexWrap: 'wrap',
  gap: theme.spacing(4)
}));
